export * from './dynamic-component.directive';
